//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'd2-container-full'
}
